export const processaValoresDefaultIniciaisConfiguracaoAcumulacao = ( values ) => {
    
    if (!values.calcularAporteAtingirMetaRecursosFinanceirosInicioAposentadoria) {

        values.calcularAporteAtingirMetaRecursosFinanceirosInicioAposentadoria = false
        values.valorCalcularAporteAtingirMetaRecursosFinanceirosInicioAposentadoria = ''
    }

    if (!values.aplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria) {

        values.aplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria = false
        values.percAplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria = ''
    }

    if (!values.deduzirComplementoReceitaMensalAteAposentadoriaReservaAposentadoria) {

        values.deduzirComplementoReceitaMensalAteAposentadoriaReservaAposentadoria = false
    }
    
    if (!values.naoExibirOpcaoAporteUnico) {

        values.naoExibirOpcaoAporteUnico = false
    }
       
    if (!values.utilizarVersaoSimplificadaGraficoDiagnosticoAposentadoriaIndependênciaFinanceira) {

        values.utilizarVersaoSimplificadaGraficoDiagnosticoAposentadoriaIndependênciaFinanceira = false
    }
    
    if (!values.naoExibirHipotesesRetornoRealAposentadoria) {

        values.naoExibirHipotesesRetornoRealAposentadoria = false
    }
    
    if (!values.calcularHipotesesRetornoRealAposentadoriaViverRentabilidade || values.naoExibirHipotesesRetornoRealAposentadoria) {

        values.calcularHipotesesRetornoRealAposentadoriaViverRentabilidade = false
    }

    if (!values.exibirRecursosFinanceirosTipoRecursoFinanceiroVersusInstituicao) {

        values.exibirRecursosFinanceirosTipoRecursoFinanceiroVersusInstituicao = false
    }

    if (!values.naoCalcularAportesNecessariosRealizacaoPVS) {

        values.naoCalcularAportesNecessariosRealizacaoPVS = false
    }

    if (!values.naoConsiderarValorAcumulacaoJaRealizadoPVS) {

        values.naoConsiderarValorAcumulacaoJaRealizadoPVS = false
    }

    if (!values.exibirHipotesesRetornoRealProjetoVidaSonho) {

        values.exibirHipotesesRetornoRealProjetoVidaSonho = false
    }
    
    if (!values.naoExibirAcumulacaoAposentadoriaProjetoVidaSonho) {

        values.naoExibirAcumulacaoAposentadoriaProjetoVidaSonho = false
    }
}